/**
 * Created by greg on 7/09/2018.
 */

import { AllSameKeyValuesEnforcer } from '../helpers/helpers'

export interface JoiFile {
  filename?: string;
  fileUrl?: string
  description?: string;
  by?: string;
  by_uid?: string;
  storageName?: string;
  created?: number
  modified?: number
  size?: any;
  timestamp?: any;
  linkUrl?: string;
}

export interface ImagePaths {
  savePath?: string, // the full save path within firebase storage
  thumbSavePath?: string, // see above
  originalName?: string
}

export interface UploadStatus extends ImagePaths {
  state?: 'uploading' | 'error' | 'uploaded' | 'invalidFile' | 'exceedsMaxSize'
}

export type ImageType = 'performer' | 'sponsor' | 'accounts' | 'profiles' | 'exhibitor' | 'asset' | 'resource' | 'header' | 'publish-slider' | 'mobile-slider' | 'event-thumb' | 'attendee'
export type ImageSubType = 'logo' | 'photo'

export interface ImageUploaderDisplayTypes { card, widePodLogo, text, action }
export const imageUploaderDisplayTypes: AllSameKeyValuesEnforcer<ImageUploaderDisplayTypes> = { card: 'card', widePodLogo: 'widePodLogo', text: 'text', action: 'action' }

export interface UploadImageData {
  eventId?: string // DON'T SET EVENT ID FOR USER PROFILE OR ACCOUNT IMAGES
  accountId?: string
  typeId: string
  fileType?: string
  type: ImageType
  onlyThumb?: 'yes' | 'no' // might change what images we store for profile and account, so better to have as an option than set in stone
  onlyMain?: 'yes' | 'no'
  subtype?: ImageSubType
  publishCode?: string // for use with public uploads
  isTemplate?: 'yes' | 'no' // CANNOT ATTACH A BOOLEAN TO FORM DATA, IT TURNS IT INTO A STRING!
}
